import React from 'react';
export function WhatYouReceive() {
  return <section className="bg-white" data-id="element-327">
      <div className="relative" data-id="element-328">
        <img src="https://cdn.magicpatterns.com/uploads/hWu3qtebXbSAswcoWxeXRB/03e1ba10-74ab-4569-b080-fe91fa744584.webp" alt="Conocé tu guía para soltar el dolor y elegirte de verdad" className="w-full h-auto block" data-id="element-329" />
      </div>
    </section>;
}